<style lang="less"></style>

<template>
    <MenuList :menuList="menuList" @handleClicks="(key) => align(key)" />
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    import MenuList from "@/app/components/MenuList.vue";

    @Component({
        components: {
            MenuList,
        },
    })
    export default class AlignMenus extends Vue {
        get menuList() {
            return {
                // container: "",
                list: [
                    { key: 0, label: this.$t("left"), shortcut: "Alt+L" },
                    { key: 1, label: this.$t("center"), shortcut: "Alt+C" },
                    { key: 2, label: this.$t("right"), shortcut: "Alt+R" },
                    // 列表中的其他项 key 为数字时，divide 项也要设置 key 值以防与后一项重复
                    { key: "divide", divide: true },
                    { key: 3, label: this.$t("top") },
                    { key: 4, label: this.$t("middle") },
                    { key: 5, label: this.$t("bottom") },
                ],
            };
        }
        closeDrop() {
            this.$emit("closeDrop");
        }
        align(type: number) {
            console.log(type);
            let strArr = ["left", "center", "right", "top", "middle", "bottom"];
            this.$track("menu", "layout", "align " + strArr[type]);
            window["_view"].alignShapes(type);
            this.closeDrop();
        }

        mounted() {}

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "left": "左对齐",
    "center": "水平居中",
    "right": "右对齐",
    "top": "顶部",
    "middle": "垂直居中",
    "bottom": "底部"
  },
  "en": {
    "left": "Align Left",
    "center": "Align Center",
    "right": "Align Right",
    "top": "Align Top",
    "middle": "Align Middle",
    "bottom": "Align Bottom"
  },
  "fr": {
    "left": "Aligner à gauche",
    "center": "Aligner à centre",
    "right": "Aligner à droite",
    "top": "Haut",
    "middle": "Aligner au milieu",
    "bottom": "Aligner en bas"
  },
  "de": {
    "left": "Linksbündig",
    "center": "Horizontal zentrieren",
    "right": "Rechtsbündig",
    "top": "Oben bündig",
    "middle": "Vertikel zentrieren ",
    "bottom": "Unten bündig"
  },
  "jp": {
    "left": "左揃え",
    "center": "左右中央揃え",
    "right": "右揃え",
    "top": "上揃え",
    "middle": "上下中央揃え",
    "bottom": "下揃え"
  },
  "es": {
    "left": "Alinear a la izquierda",
    "center": "Alinear el centro",
    "right": "Alinear a la derecha",
    "top": "Alinear arriba",
    "middle": "Alinear el medio",
    "bottom": "Alinear el fondo"
  },
  "pt": {
    "left": "Alinhar à Esquerda",
    "center": "Alinhar ao Centro",
    "right": "Alinhar à Direita",
    "top": "Alinhar em Cima",
    "middle": "Alinhar ao Meio",
    "bottom": "Alinhar em Baixo"
  },
  "it": {
    "left": "Allinea a Sinistra",
    "center": "Allinea al Centro",
    "right": "Allinea a Destra",
    "top": "Allinea in Alto",
    "middle": "Allinea al Centro",
    "bottom": "Allinea in Basso"
  },
  "tw": {
    "left": "左對齊",
    "center": "水平居中",
    "right": "右對齊",
    "top": "頂部",
    "middle": "垂直居中",
    "bottom": "底部"
  }
}
</i18n>
